import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from "clsx";
import styles from "./delimiter.module.css";
export const Delimiter = ({ className, text }) => {
    return (_jsxs("div", { className: clsx(className, styles.wrapper), children: [text && _jsx("span", { className: styles.text, children: text }), _jsx("div", { className: styles.delimiter })] }));
};
export default Delimiter;
